var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _g5, _path11, _path12, _g6, _path13, _path14, _g7, _path15, _path16, _g8, _path17, _path18, _g9, _path19, _path20, _g10, _path21, _path22, _g11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoNomanejes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 28,
    viewBox: "0 0 96 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12104_5976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 10,
    width: 11,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35156 10.9536H17.1912V22.7876H7.35156V10.9536Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12104_5976)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_12104_5976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 11,
    width: 11,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0206 17.1916L9.87976 14.8656H9.83332V22.7315H7.38867V11.0356H10.2294L13.4889 16.5532L14.6298 18.8783H14.6771V11.0356H17.1218V22.7092H14.281L11.0206 17.1916Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_12104_5976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.0273438 0.795654H95.9059V27.6044H-0.0273438V0.795654Z",
    fill: "#061E3C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_12104_5976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 13,
    width: 9,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3672 13.6763H26.8474V22.9578H18.3672V13.6763Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_12104_5976)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_12104_5976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 13,
    width: 9,
    height: 10
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6382 20.9538C23.1508 20.9538 23.5232 20.7942 23.8027 20.4973C24.0823 20.2013 24.2225 19.768 24.2225 19.2206V17.4421C24.2225 16.8947 24.0823 16.4614 23.8027 16.1654C23.5232 15.8685 23.1508 15.709 22.6382 15.709C22.1265 15.709 21.7541 15.8685 21.4746 16.1654C21.1951 16.4614 21.0549 16.8947 21.0549 17.4421V19.2206C21.0549 19.768 21.1951 20.2013 21.4746 20.4973C21.7541 20.8165 22.1493 20.9538 22.6382 20.9538ZM22.6382 22.9142C21.9863 22.9142 21.3808 22.8001 20.8692 22.595C20.3566 22.39 19.9141 22.0708 19.5653 21.683C19.2157 21.2729 18.9362 20.7942 18.7268 20.2236C18.5401 19.6539 18.4473 19.0156 18.4473 18.3086C18.4473 17.6017 18.5401 16.9633 18.7268 16.3937C18.9134 15.8231 19.192 15.3443 19.5653 14.9565C19.9141 14.5696 20.3566 14.2504 20.8692 14.0454C21.3808 13.8395 21.9863 13.7253 22.6382 13.7253C23.291 13.7253 23.8956 13.8395 24.4082 14.0454C24.9208 14.2504 25.3633 14.5696 25.712 14.9565C26.0617 15.3443 26.3412 15.8231 26.5506 16.3937C26.7372 16.9633 26.8301 17.6017 26.8301 18.3086C26.8301 19.0156 26.7372 19.6539 26.5506 20.2236C26.3639 20.7942 26.0844 21.2729 25.712 21.683C25.3633 22.0931 24.9208 22.39 24.4082 22.595C23.8956 22.8001 23.3138 22.9142 22.6382 22.9142Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_12104_5976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.0273438 0.795654H95.9059V27.6044H-0.0273438V0.795654Z",
    fill: "#061E3C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_12104_5976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 10,
    width: 12,
    height: 13
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0996 10.9536H39.5435V22.7297H28.0996V10.9536Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_12104_5976)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_12104_5976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 11,
    width: 12,
    height: 12
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0488 15.0484L36.1647 16.7583L33.8357 20.8851L31.554 16.7806L30.6454 14.9342H30.5989V22.7092H28.1543V11.0356H30.9021L33.813 16.5078H33.8357L36.7229 11.0356H39.4944V22.7092H37.0488V15.0484Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_12104_5976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.0273438 0.795654H95.9059V27.6044H-0.0273438V0.795654Z",
    fill: "#061E3C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_12104_5976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 13,
    width: 10,
    height: 10
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.832 13.6763H49.4889V22.9578H40.832V13.6763Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_12104_5976)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_12104_5976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 13,
    width: 10,
    height: 10
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5497 21.2043C44.9694 21.2043 45.3418 21.1134 45.6213 20.9306C45.9236 20.7478 46.0866 20.4518 46.0866 20.064V19.0379H44.8529C43.875 19.0379 43.3624 19.3571 43.3624 20.0186V20.2691C43.3624 20.5882 43.4553 20.8397 43.6656 20.9761C43.875 21.1134 44.1773 21.2043 44.5497 21.2043ZM48.066 22.7092C47.6007 22.7092 47.2274 22.5719 46.9251 22.2982C46.6229 22.0254 46.4362 21.6376 46.3661 21.1811H46.2732C46.133 21.7517 45.8307 22.185 45.3655 22.4809C44.8993 22.7769 44.3175 22.9142 43.6419 22.9142C42.7342 22.9142 42.0586 22.686 41.5697 22.2072C41.1035 21.7285 40.8477 21.1134 40.8477 20.3609C40.8477 19.4257 41.1973 18.7419 41.872 18.2855C42.5712 17.8299 43.5026 17.6017 44.6899 17.6017H46.1103V17.0543C46.1103 16.621 45.9937 16.3018 45.7606 16.0513C45.5285 15.8008 45.1552 15.6867 44.6198 15.6867C44.1081 15.6867 43.712 15.8008 43.4325 16.0059C43.1293 16.2109 42.8972 16.4614 42.7105 16.7128L41.1973 15.413C41.5697 14.8888 42.0122 14.4778 42.5712 14.1818C43.1293 13.8849 43.875 13.7485 44.8064 13.7485C46.0866 13.7485 47.0417 14.0222 47.6699 14.5696C48.2991 15.117 48.625 15.9149 48.625 16.9633V20.8165H49.4636V22.7315H48.066V22.7092Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_12104_5976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.0292969 0.795654H95.904V27.6044H-0.0292969V0.795654Z",
    fill: "#061E3C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_12104_5976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 13,
    width: 9,
    height: 10
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4512 13.6763H58.4725V22.7876H50.4512V13.6763Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_12104_5976)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_12104_5976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 13,
    width: 9,
    height: 10
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5488 22.7092V13.9313H53.0873V15.413H53.1801C53.3431 14.9565 53.6226 14.5696 54.0187 14.2273C54.4147 13.8849 54.9729 13.7253 55.6721 13.7253C56.6036 13.7253 57.2782 14.0222 57.7672 14.6374C58.2333 15.2302 58.4664 16.0968 58.4664 17.2138V22.7092H55.928V17.4198C55.928 16.8492 55.8351 16.4391 55.6485 16.1654C55.4627 15.8917 55.1359 15.7553 54.6706 15.7553L54.0651 15.8231C53.8785 15.8685 53.6927 15.9604 53.5525 16.0745L53.1801 16.4846C53.0873 16.6442 53.0408 16.8269 53.0408 17.0543V22.7314H50.5488V22.7092Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_12104_5976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.0292969 0.795654H95.904V27.6044H-0.0292969V0.795654Z",
    fill: "#061E3C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_12104_5976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 13,
    width: 9,
    height: 10
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.543 13.6763H67.9923V22.9578H59.543V13.6763Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_12104_5976)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_12104_5976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 13,
    width: 9,
    height: 10
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8138 15.5494C63.3021 15.5494 62.9061 15.709 62.6038 16.0513C62.3243 16.3705 62.1613 16.827 62.1613 17.3735V17.5107H65.3043V17.3512C65.3043 16.827 65.1877 16.3937 64.9319 16.0513C64.6988 15.7322 64.3264 15.5494 63.8138 15.5494ZM63.8611 22.9142C63.1856 22.9142 62.5564 22.8001 62.0211 22.5951C61.4857 22.3668 61.0432 22.0709 60.6708 21.683C60.2984 21.2952 60.0189 20.8165 59.8323 20.2468C59.6465 19.6762 59.5527 19.0379 59.5527 18.3309C59.5527 17.6472 59.6465 17.0088 59.8323 16.4614C60.0189 15.8918 60.2747 15.413 60.6471 15.0252C60.9968 14.6151 61.4393 14.3182 61.9746 14.0909C62.4872 13.8627 63.0927 13.7717 63.7674 13.7717C64.5131 13.7717 65.1413 13.885 65.6767 14.1364C66.2129 14.3869 66.6318 14.706 66.9814 15.117C67.3073 15.5271 67.5632 16.0059 67.7262 16.5533C67.8891 17.0998 67.9592 17.6703 67.9592 18.24V18.9702H62.2077V19.1066C62.2077 19.6762 62.3707 20.155 62.673 20.4973C62.9989 20.8397 63.4879 20.9993 64.1871 20.9993C64.6988 20.9993 65.1413 20.9074 65.4672 20.6801L66.3987 19.9277L67.6561 21.478C67.26 21.9336 66.7483 22.2982 66.0964 22.5496C65.4208 22.7769 64.676 22.9142 63.8611 22.9142Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_12104_5976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.0273438 0.795654H95.9059V27.6044H-0.0273438V0.795654Z",
    fill: "#061E3C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_12104_5976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 13,
    width: 5,
    height: 14
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7773 13.886H71.7343V26.5571H67.7773V13.886Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_12104_5976)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_12104_5976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 13,
    width: 5,
    height: 14
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1176 13.9314H71.656V23.9672C71.656 24.7678 71.4466 25.3811 71.0506 25.8278C70.6545 26.2522 70.0026 26.4643 69.1176 26.4643H67.791V24.1981H69.1176V13.9314Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_12104_5976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.0273438 0.795898H95.9059V27.6047H-0.0273438V0.795898Z",
    fill: "#061E3C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_12104_5976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 10,
    width: 4,
    height: 4
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8477 10.1772H71.8422V13.0479H68.8477V10.1772Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_12104_5976)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_12104_5976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 10,
    width: 4,
    height: 3
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70.375 12.9961C69.8633 12.9961 69.49 12.882 69.2578 12.6538C69.0247 12.4264 68.9082 12.1296 68.9082 11.7649V11.4003C68.9082 11.0357 69.0247 10.762 69.2578 10.5337C69.49 10.3055 69.8633 10.1914 70.375 10.1914C70.8876 10.1914 71.26 10.3055 71.4931 10.5337C71.7262 10.762 71.8418 11.058 71.8418 11.4003V11.7649C71.8418 12.1296 71.7262 12.4264 71.4931 12.6538C71.26 12.882 70.9113 12.9961 70.375 12.9961Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_12104_5976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.0273438 0.795654H95.9059V27.6044H-0.0273438V0.795654Z",
    fill: "#061E3C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_12104_5976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 13,
    width: 10,
    height: 10
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8047 13.6763H81.2531V22.9578H72.8047V13.6763Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_12104_5976)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_12104_5976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 13,
    width: 10,
    height: 10
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1048 15.5494C76.5931 15.5494 76.1971 15.709 75.8939 16.0513C75.6153 16.3705 75.4523 16.827 75.4523 17.3735V17.5107H78.5953V17.3512C78.5953 16.827 78.4787 16.3937 78.2229 16.0513C77.9898 15.7322 77.6174 15.5494 77.1048 15.5494ZM77.1513 22.9142C76.4766 22.9142 75.8474 22.8001 75.3121 22.5951C74.7767 22.3668 74.3342 22.0709 73.9618 21.683C73.5894 21.2952 73.3099 20.8165 73.1233 20.2468C72.9366 19.6762 72.8438 19.0379 72.8438 18.3309C72.8438 17.6472 72.9366 17.0088 73.1233 16.4614C73.3099 15.8918 73.5658 15.413 73.9382 15.0252C74.2878 14.6151 74.7303 14.3182 75.2656 14.0909C75.7782 13.8627 76.3828 13.7717 77.0584 13.7717C77.8041 13.7717 78.4323 13.885 78.9677 14.1364C79.503 14.3869 79.9228 14.706 80.2715 15.117C80.5974 15.5271 80.8542 16.0059 81.0172 16.5533C81.1802 17.0998 81.2503 17.6703 81.2503 18.24V18.9702H75.4987V19.1066C75.4987 19.6762 75.6617 20.155 75.964 20.4973C76.2899 20.8397 76.7789 20.9993 77.4772 20.9993C77.9898 20.9993 78.4323 20.9074 78.7583 20.6801L79.6897 19.9277L80.9471 21.478C80.551 21.9336 80.0393 22.2982 79.3874 22.5496C78.6882 22.7769 77.967 22.9142 77.1513 22.9142Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_12104_5976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.0273438 0.795654H95.9059V27.6044H-0.0273438V0.795654Z",
    fill: "#061E3C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_12104_5976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 81,
    y: 13,
    width: 9,
    height: 10
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M81.623 13.6763H89.2748V22.9578H81.623V13.6763Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_12104_5976)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_12104_5976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 81,
    y: 13,
    width: 9,
    height: 10
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4382 22.9142C84.5768 22.9142 83.8548 22.7769 83.2493 22.5041C82.6675 22.2304 82.1322 21.8426 81.666 21.3407L83.1565 19.8822C83.4824 20.2236 83.8321 20.4973 84.2044 20.7024C84.6005 20.9074 85.0193 20.9992 85.5083 20.9992C86.0209 20.9992 86.3468 20.9306 86.5562 20.771C86.742 20.6114 86.8357 20.4064 86.8357 20.155C86.8357 19.7449 86.5326 19.4943 85.9271 19.4257L84.9492 19.3116C82.9234 19.0611 81.9228 18.1713 81.9228 16.5987C81.9228 16.1654 82.0156 15.7776 82.1786 15.4362C82.3416 15.0938 82.5747 14.7747 82.877 14.5241C83.1802 14.2727 83.5525 14.0909 83.9714 13.9313C84.3902 13.794 84.88 13.7253 85.4154 13.7253C85.8807 13.7253 86.3004 13.7485 86.6491 13.8172L87.6042 14.0909C87.8837 14.205 88.1396 14.3646 88.3726 14.5241L89.071 15.0938L87.627 16.5532C87.3474 16.2795 87.0215 16.0513 86.6728 15.8917C86.3231 15.7321 85.9508 15.6412 85.5784 15.6412C85.1359 15.6412 84.8327 15.709 84.6469 15.8463C84.4603 15.9827 84.3674 16.1654 84.3674 16.3705C84.3674 16.5987 84.4375 16.7806 84.5532 16.9179C84.6934 17.0543 84.9265 17.1461 85.2989 17.1916L86.3004 17.328C88.2789 17.5794 89.2567 18.4682 89.2567 19.9731C89.2567 20.4064 89.1639 20.7942 88.9781 21.1356C88.7915 21.5003 88.5356 21.7971 88.2097 22.0708C87.8837 22.3445 87.464 22.5496 86.9987 22.686C86.5562 22.8456 86.0209 22.9142 85.4382 22.9142Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_12104_5976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.0273438 0.795654H95.9059V27.6044H-0.0273438V0.795654Z",
    fill: "#061E3C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_12104_5976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 94,
    height: 26
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1.04102 1.84326H94.8346V26.557H1.04102V1.84326Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_12104_5976)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_12104_5976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 94,
    height: 26
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7097 26.4617H7.03289C3.77517 26.4617 1.13477 23.8745 1.13477 20.6864V7.71128C1.13477 4.52143 3.77517 1.93604 7.03289 1.93604H88.8473C92.105 1.93604 94.7454 4.52143 94.7454 7.71128V20.6864C94.7454 23.8763 92.105 26.4617 88.8473 26.4617H72.6078V24.182H88.8473C90.8194 24.182 92.4164 22.6174 92.4164 20.6864V7.71128C92.4164 5.78025 90.8194 4.21564 88.8473 4.21564H7.03289C5.06078 4.21564 3.46379 5.78025 3.46379 7.71128V20.6864C3.46379 22.6174 5.06078 24.182 7.03289 24.182H66.7097V26.4617Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_12104_5976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.0292969 0.795898H95.904V27.6047H-0.0292969V0.795898Z",
    fill: "#061E3C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNomanejes);
export default __webpack_public_path__ + "static/media/logo_nomanejes.1ad4029edd338f6570135d9068d4e3ed.svg";
export { ForwardRef as ReactComponent };